import { AbilityBuilder, Ability } from "casl";
import moment from "moment";
import * as features from "./feature.types";
import { MANAGE, CREATE, READ, UPDATE, DELETE } from "./action.types";

function defineRulesForBasicAccess(can) {
  can(MANAGE, features.ACCOUNT);
  can(READ, features.DASHBOARD);
  can(READ, features.ACTIVITY);
}

function hasExpired({ plan, trialPeriod, endDate }) {
  return (!plan && !trialPeriod) || moment().isAfter(endDate);
}

function defineRulesForBookingSystem(can) {
  can(MANAGE, features.BOOKINGS);
  can(MANAGE, features.MANAGEMENT);
}

function defineRulesForBarberBookingSystem(can) {
  defineRulesForBookingSystem(can);
  can(MANAGE, features.EMPLOYEES);
  can(MANAGE, features.SERVICES);
  can(MANAGE, features.ROSTER);
  can(MANAGE, features.ONLINE_PAYMENTS);
  can(READ, features.ACCOUNTING);
  can([READ, DELETE], features.CUSTOMERS);
}

function defineRulesForAccountingSystem(can) {
  can(MANAGE, features.ACCOUNTING);
  can(MANAGE, features.INVOICES);
  can(MANAGE, features.RECURRING_INVOICES);
  can(MANAGE, features.CREDIT_NOTES);
  can(MANAGE, features.CUSTOMERS);
  can(MANAGE, features.CUSTOMER_STATEMENTS);
  can(MANAGE, features.PAYMENT_REMINDERS);
  can(MANAGE, features.ONLINE_PAYMENTS);
}

export function defineRulesFor(subscription, options) {
  const { can, rules } = AbilityBuilder.extract();

  defineRulesForBasicAccess(can);

  if (options && options.protectedTenant) {
    defineRulesForBarberBookingSystem(can);
    defineRulesForAccountingSystem(can);
    return rules;
  }

  if (!subscription || hasExpired(subscription)) return rules;

  defineRulesForBarberBookingSystem(can);
  defineRulesForAccountingSystem(can);

  return rules;
}

export function defineAbilityFor(subscription) {
  return new Ability(defineRulesFor(subscription));
}

const ability = defineAbilityFor(null);

export default ability;
